import "@fontsource/roboto/latin.css";
import { colors, createTheme, darken } from "@mui/material";
import type { ThemeOptions } from "@mui/material";

const components: ThemeOptions["components"] = {
  MuiModal: {
    defaultProps: {
      // Prevent main content scrollbar flicker when dialogs open or close.
      disableScrollLock: true,
    },
  },
  MuiPopover: {
    defaultProps: {
      // Prevent main content scrollbar flicker when popovers open or close.
      disableScrollLock: true,
    },
  },
  MuiTable: {
    defaultProps: {
      size: "small",
    },
  },
  MuiSnackbar: {
    defaultProps: {
      anchorOrigin: { vertical: "top", horizontal: "center" },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: ({ theme, ownerState }) => (ownerState.padding === "normal" ? { [theme.breakpoints.down("md")]: { paddingInline: theme.spacing(1) } } : {}),
      stickyHeader: ({ theme }) => ({ backgroundColor: theme.palette.background.paper }),
    },
  },
};

export const theme = createTheme({
  components,
  palette: {
    primary: {
      main: colors.teal[600],
    },
    secondary: {
      main: colors.indigo[500],
    },
    background: {
      default: colors.blueGrey[50],
    },
  },
});

export const darkTheme = createTheme({
  components,
  palette: {
    mode: "dark",
    primary: {
      main: colors.teal.A200,
      dark: colors.teal[200],
    },
    secondary: {
      main: colors.indigo[200],
    },
    background: {
      default: darken(colors.blueGrey[900], 0.65),
      paper: darken(colors.blueGrey[900], 0.4),
    },
  },
});
